import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X, Crown } from 'lucide-react';

const mainLinks = [
  { name: 'Diensten', href: '/diensten' },
  { name: 'Hoe het werkt', href: '/werkwijze' },
  { name: 'Prijzen', href: '/prijzen' },
  { name: 'Over ons', href: '/over-ons' },
  { name: 'Blog', href: '/blog' },
  { name: 'Partner worden', href: '/partner-worden' },
  { name: 'Contact', href: '/contact' },
];

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    if (!location.hash) window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location]);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/98 backdrop-blur-md shadow-sm py-3' : 'bg-white/95 backdrop-blur-sm py-4'
    } border-b border-gray-100`}>
      <div className="container-custom">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" data-testid="header-logo" className="flex items-center gap-2.5 group">
            <div className="w-9 h-9 bg-[#0f172a] rounded-lg flex items-center justify-center group-hover:bg-[#1e293b] transition-colors">
              <Crown className="w-5 h-5 text-[#D4A017]" />
            </div>
            <div>
              <span className="text-base font-bold text-[#0f172a] font-serif leading-none block">IMPERIA AI</span>
              <span className="text-[10px] text-[#D4A017] font-medium leading-none block">AI Marketing Manager</span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-6">
            {mainLinks.map(link => (
              <Link key={link.name} to={link.href} data-testid={`header-link-${link.name.toLowerCase().replace(/\s/g, '-')}`}
                className="text-sm font-medium text-[#64748b] hover:text-[#0f172a] transition-colors">
                {link.name}
              </Link>
            ))}
          </nav>

          {/* CTA */}
          <div className="hidden lg:flex items-center gap-3">
            <Link to="/login" className="text-sm font-medium text-[#64748b] hover:text-[#0f172a] transition-colors">
              Inloggen
            </Link>
            <Link to="/register" data-testid="header-cta-scan">
              <Button className="bg-[#D4A017] hover:bg-[#B8860B] text-[#0f172a] font-bold px-5 py-2.5 rounded-xl">
                Start gratis scan →
              </Button>
            </Link>
          </div>

          {/* Mobile */}
          <button data-testid="mobile-menu-toggle" className="lg:hidden p-2 text-[#64748b]" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            {isMobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-100 pt-4">
            <div className="flex flex-col gap-3">
              {mainLinks.map(link => (
                <Link key={link.name} to={link.href} className="text-[#64748b] font-medium text-sm hover:text-[#0f172a] py-1.5">
                  {link.name}
                </Link>
              ))}
              <div className="flex gap-2 mt-2">
                <Link to="/login" className="flex-1 text-center py-2.5 border border-gray-200 text-[#64748b] rounded-xl text-sm font-medium">Inloggen</Link>
                <Link to="/register" className="flex-1 text-center py-2.5 bg-[#D4A017] text-[#0f172a] rounded-xl text-sm font-bold">Gratis scan</Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};
